import { render } from "./TariffMiniComponent.vue?vue&type=template&id=05656c84&scoped=true"
import script from "./TariffMiniComponent.vue?vue&type=script&lang=js"
export * from "./TariffMiniComponent.vue?vue&type=script&lang=js"

import "./TariffMiniComponent.vue?vue&type=style&index=0&id=05656c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05656c84"]])

export default __exports__